import React, { useCallback, useState } from 'react';
import cx from '@3ui/cx';

import { useLocation, useNavigate } from 'react-router-dom';

import S from './ColorSelector.module.css';

const bit16 = '0123456789abcdef'.split('');
const bit16Length = bit16.length;
const generateRandomColors = (hash?) => {
  const randomColors = Array.from({ length: 8 })
    .map(() =>
      Array.from({ length: 6 })
        .map(() => bit16[Math.round(Math.random() * (bit16Length - 1))])
        .join('')
    )
    .map((i) => `#${i}`);
  const colorsList = ['#ffffff', ...randomColors, '#000000'];
  if (hash && !colorsList.includes(hash)) {
    colorsList[1] = `#${hash}`;
  }
  return colorsList;
};

const getHash = (asPath) => asPath.split('#')[1];

const ColorSelector = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hash = getHash(location.hash);
  const [state, setState] = useState(generateRandomColors(hash));

  const randomize = useCallback(() => {
    const colors = generateRandomColors();
    setState(() => colors);
    if (colors[1] !== hash) {
      navigate(`/iphone${colors[1]}`);
    }
  }, [hash, navigate]);

  return (
    <div className={S.root}>
      <ul className={S.ul}>
        {state.map((color, idx) => (
          <li key={idx} className={cx(S.li, color === `#${hash}` && S.on)}>
            <a className={S.a} href={color} style={{ background: color }} />
          </li>
        ))}
      </ul>
      <button className={S.button} onClick={randomize}>
        Random
      </button>
    </div>
  );
};

export default ColorSelector;
